export default function sortLinks(links) {
  return links.slice(0).sort((a, b) => {
    const aPos = a.position() ?? 0;
    const bPos = b.position() ?? 0;
    return aPos - bPos;
  });
}
flarum.reg.add('fof-links', 'common/utils/sortLinks', sortLinks);